<div class="message-edit" (click)="onClickMessage(messageId)">
  <p class="message-edit__sender">
    {{ message?.senderId | senderFullName | async }}
  </p>

  <div class="message-edit__content">
    <span class="message-edit__text">
      {{ message | messageNote | async }}
    </span>
  </div>
</div>
